;(function() {
  'use strict'

  controller.$inject = ["AUTH_EVENTS", "$scope", "feedService"];
  angular.module('app.thefeed').controller('TheFeed', controller)

  /* @ngInject */
  function controller(AUTH_EVENTS, $scope, feedService) {
    $scope.feed = feedService.get({ top: 150 })

    $scope.$on(AUTH_EVENTS.loginSuccess, $scope.feed.refresh)
    $scope.$on(AUTH_EVENTS.logoutSuccess, $scope.feed.refresh)
  }
})()
